<template>
    <div>
        <v-list dense tile>
            <v-list-item-group v-model="item" color="primary">
                <v-list-item v-for="(cat, index) in countries" :key="(cat.id)">
                    <template v-if="editOffset !== index">
                        <v-list-item-content class="pa-0" @click="startEditing(index)">
                            {{cat.name}}
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="deleteCountry(cat.id)">mdi-delete</v-icon>
                        </v-list-item-icon>
                    </template>

                    <template v-if="editOffset===index">
                        <v-list-item-content class="pa-0" @keydown.esc="cancelEditing" @keydown.enter="updateCountry(cat.id)">
                            <v-text-field dense v-model="tempValue" required> {{ tempValue }}
                            </v-text-field>
                        </v-list-item-content>

                        <v-list-item-icon>
                            <v-icon medium @click="updateCountry(cat.id)">mdi-content-save</v-icon>
                            <v-icon medium @click="cancelEditing">mdi-close-circle</v-icon>
                        </v-list-item-icon>
                    </template>
                </v-list-item>

                <v-list-item v-for="(input, index) in inputs" :key="index">
                    <v-list-item-content class="pa-0">
                        <v-text-field dense v-model="input.one" required> {{ input.one }}
                        </v-text-field>
                    </v-list-item-content>
                    <v-list-item-icon justify="space-around">
                        <span class="group">                  
                            <v-icon medium @click="createCountry(index)" :disabled="input.one === ''">mdi-plus-circle</v-icon> 
                            <v-icon medium @click="deleteRow(index)">mdi-close-circle</v-icon>  
                        </span>                    
                    </v-list-item-icon>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <div class="text-center pt-2">
            <v-btn color="secondary" class="black--text" :disabled="disableAdd" small @click="addRow">إضافة مطبخ</v-btn>
        </div>

    </div>
</template>

<script>
    import {
        GET_COUNTRIES,
        ADD_COUNTRY,
        UPDATE_COUNTRY,
        DELETE_COUNTRY 
    } from '../graphql/Countries'

    export default {
        data() {
            return {
                item: -1,
                countries: '',
                disableAdd: false,
                editOffset: -1,
                tempValue: null,
                inputs: []
            }
        },
        apollo: {
            countries: {
                query: GET_COUNTRIES
            }
        },
        methods: {
            addRow() {
                this.disableAdd = true
                this.inputs.push({
                    one: ''
                })
            },
            deleteRow(index) {
                this.disableAdd = false
                this.inputs.splice(index, 1)
            },
            startEditing: function (index) {
                this.disableAdd = true
                this.editOffset = index;
                this.tempValue = this.countries[index].name
            },
            cancelEditing: function () {
                this.disableAdd = false
                this.editOffset = -1;
                this.tempValue = null;
            },
            createCountry(index) {
                this.$apollo.mutate({
                    mutation: ADD_COUNTRY,
                    variables: {
                        name: this.inputs[index].one,
                    },
                    update: (cache, {data: {createCountry} }) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_COUNTRIES
                        })

                        // Create updated data
                        data.countries.push(createCountry)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_COUNTRIES,
                            data
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        createCountry: {
                            __typename: 'Country',
                            name: this.inputs[index].one
                        }
                    }

                }).then(({
                    data
                }) => {
                    this.disableAdd = false
                    this.inputs.splice(index, 1)
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            updateCountry(id) {
                this.$apollo.mutate({
                    mutation: UPDATE_COUNTRY,
                    variables: {
                        id: id,
                        name: this.tempValue,
                    },
                    update: (cache, {data: { updateCountry }}) => {
                        //First read the query you want to update

                        const data = cache.readQuery({
                            query: GET_COUNTRIES
                        })

                        let index = data.countries.findIndex(category => category.id === updateCountry.id) 

                        let updatedCountries = [
                            ...data.countries.slice(0, index),
                            updateCountry,
                            ...data.countries.slice(index + 1)
                        ]
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_COUNTRIES,
                            data: updatedCountries
                        })
                    },
                    // Ensures data is added immediately

                    optimisticResponse: {
                        __typename: 'Mutation',
                        updateCountry: {
                            __typename: 'Country',
                            name: this.tempValue
                        }
                    }

                }).then(({data}) => {
                    this.disableAdd = false
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            },
            deleteCountry(id) {
                this.$apollo.mutate({
                    mutation: DELETE_COUNTRY,
                    variables: {
                        id: id
                    },
                    update: (cache, {data: { deleteCountry }}) => {
                        //First read the query you want to update
                        const data = cache.readQuery({
                            query: GET_COUNTRIES
                        })

                        let index = data.countries.findIndex(category => category.id === deleteCountry.id) 

                        data.countries.splice(index, 1)
                        // Write updated data back to the query
                        cache.writeQuery({
                            query: GET_COUNTRIES,
                            data
                        })
                    },

                }).then(({data}) => {
                    this.editOffset = -1
                    return data
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style scoped>
  .tile {
    margin: 5px;
    border-radius: 4px;
  }
  .tile:hover {
    background: green;
  }
  .tile:active {
    background: yellow;
  }
</style>